export default __webpack_public_path__ + "static/media/sun.816aa12b.svg";